module.exports = __webpack_public_path__ + "static/media/codingblocks.d9344dc9.png";